import ImageWithFallback from '@/components/shared/ImageWithFallback';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/shared/icons';
export default function DesktopOnboarding({
  runAuthFlow
}) {
  return <div data-sentry-component="DesktopOnboarding" data-sentry-source-file="DesktopOnboarding.tsx">
      <div className='w-full p-2 flex flex-col justify-center items-center relative'>
        <div className={`flex-grow w-full my-2 rounded-md `}>
          <div className='z-10 flex flex-col'>
            <>
              <div className='ta-c items-center justify-start text-genius-pink space-x-2 mt-10'>
                <ImageWithFallback src='/static/genius.png' height={36} width={36} alt='logo' data-sentry-element="ImageWithFallback" data-sentry-source-file="DesktopOnboarding.tsx" />
                <div className='mt-8 text-genius-gradient-dark text-[18px] z-20'>Welcome.</div>
              </div>
              <div className='text-center text-[56px] tracking-tighter text-genius-cream mt-2 mb-12'>
                Genius
              </div>
              <div className='flex flex-col w-full px-2 mt-4 lg:mt-0'>
                <div className='flex flex-col items-center justify-center lg:px-4'>
                  <div className='w-full grid-cols-1 ta-c'>
                    <div>
                      <Button variant='ghost' className='w-[356px] mt-2 rounded-full bg-genius-pink text-genius-indigo transition-all duration-300 h-[56px] relative' onClick={() => runAuthFlow('genius-google')} data-sentry-element="Button" data-sentry-source-file="DesktopOnboarding.tsx">
                        <ImageWithFallback src='/static/images/google_logo.png' width={16} height={16} alt='google' className='mr-6' data-sentry-element="ImageWithFallback" data-sentry-source-file="DesktopOnboarding.tsx" />
                        Sign in with Google
                      </Button>
                    </div>
                    <div>
                      <Button variant='ghost' className='w-[356px] mt-2 rounded-full bg-genius-pink text-genius-indigo transition-all duration-300 h-[56px]' onClick={() => runAuthFlow('apple')} data-sentry-element="Button" data-sentry-source-file="DesktopOnboarding.tsx">
                        <Icons.apple className='mr-6 h-4 w-4' data-sentry-element="unknown" data-sentry-source-file="DesktopOnboarding.tsx" />
                        Sign in with Apple
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </div>;
}